import styled from 'styled-components';

export const StyledExplanation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  color: black;
  font-size: 20px;

  .translation {
    margin-bottom: 10px;
    text-align: center;
    font-weight: bold;
  }

  .explanation {
    padding: 5px;
    text-align: center;
  }
`;
